<template>
  <div>
    <span class="input-label">
      {{ $t('App.NumberOfParticipantsLabel') }}
    </span>
    <multiselect
      v-model="syncedCapacity"
      class="multiselect-is-single"
      :close-on-select="true"
      :placeholder="$t('App.NumberOfParticipantsPlaceholder')"
      :options="capacities"
      :max-height="200"
      label="name"
      open-direction="bottom"
      track-by="value"
      @input="update"
    />
    <span class="input-label">{{ $t('App.Building') }}</span>
    <multiselect
      v-model="syncedBuilding"
      class="multiselect-is-single"
      :close-on-select="true"
      :placeholder="$t('App.BuildingPlaceholder')"
      :options="buildings"
      label="name"
      open-direction="bottom"
      track-by="id"
      @input="update"
    >
      <template #option="{ option }">
        <div class="flex items-center justify-between">
          {{ option.name }}
          <FavouriteButton
            :id="option.id"
            type="building"
          />
        </div>
      </template>
    </multiselect>
    <span class="input-label">{{ $t('App.Location') }}</span>
    <multiselect
      v-model="syncedLocation"
      class="multiselect-is-single"
      :close-on-select="true"
      :placeholder="$t('App.LocationPlaceholder')"
      :options="locations"
      :custom-label="locationLabel"
      open-direction="bottom"
      track-by="id"
      @input="update"
    >
      <template #option="{ option }">
        <div class="flex items-center justify-between">
          {{ locationLabel(option) }}
          <FavouriteButton
            :id="option.id"
            type="location"
          />
        </div>
      </template>
    </multiselect>
    <span class="input-label">{{ $t('App.Equipment') }}</span>
    <multiselect
      v-model="syncedEquipment"
      class="multiselect-is-multiple"
      :close-on-select="false"
      :multiple="true"
      :placeholder="$t('App.EquipmentPlaceholder')"
      :options="availableEquipment"
      :max-height="400"
      label="name"
      open-direction="bottom"
      track-by="id"
      @input="update"
    />
    <label class="flex items-center cursor-pointer mt-2 group">
      <input
        v-model="syncedOnlyFree"
        type="checkbox"
        class="checkbox"
      >
      <span class="input-label transition group-hover:text-neutral-gray-700">{{ $t('App.OnlyFree') }}</span>
    </label>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import FavouriteButton from './FavouriteButton.vue'

export default {
  name: 'AdvancedSearch',
  components: {
    Multiselect,
    FavouriteButton,
  },
  props: {
    buildings: {
      required: true,
      type: Array,
    },
    locations: {
      required: true,
      type: Array,
    },
    availableEquipment: {
      required: true,
      type: Array,
    },
    equipment: {
      required: true,
      type: Array,
    },
    building: {
      required: true,
      validator: (value) => typeof value === 'object' || value == null,
    },
    location: {
      required: true,
      validator: (value) => typeof value === 'object' || value == null,
    },
    capacity: {
      required: true,
      validator: Object,
    },
    capacities: {
      type: Array,
      required: true,
    },
    onlyFree: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    syncedEquipment: {
      get () {
        return this.equipment
      },
      set (eq) {
        this.$emit('update-equipment', eq)
      },
    },
    syncedBuilding: {
      get () {
        return this.building
      },
      set (building) {
        this.$emit('update-building', building)
      },
    },
    syncedLocation: {
      get () {
        return this.location
      },
      set (loc) {
        this.$emit('update-location', loc)
      },
    },
    syncedCapacity: {
      get () {
        return this.capacity
      },
      set (cap) {
        const value = cap ?? []
        this.$emit('update-capacity', value)
      },
    },
    syncedOnlyFree: {
      get () {
        return this.onlyFree
      },
      set (value) {
        this.$emit('update-only-free', value)
      },
    },
  },
  methods: {
    update () {
      this.$emit('search')
    },
    locationLabel (location) {
      if (this.building) {
        return location.name
      }

      return `${this.buildings.find(b => b.id === location.building_id).name} — ${location.name}`
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
